import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Numpad from "../components/Buy/Numpad";
import Balance from "../components/Buy/Balance";
import Crypto from "../components/Buy/Crypto";
import Button from "../components/Button";
import Error from "../components/Buy/Error";
import {
  newUUID,
  getRates,
  storeParams,
  resetError,
  getIP,
} from "../actions/buy";

const Buy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [payID, hidePayID] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const address = searchParams.get("address");
  const code = searchParams.get("code");
  const idate = searchParams.get("idate");
  const uid = searchParams.get("uid");
  const partnerCode = searchParams.get("partnerCode");

  const { errors, order_id, fiat_amount, params } = useSelector(
    (state) => state.buy
  );
  const { messages } = errors;
  const { currencyCode, currencySymbol } = params;

  useEffect(() => {
    //
    dispatch(getIP());
    dispatch(newUUID("order_id"));

    // reset errors on cleanup
    return () => {
      dispatch(resetError());
    };
  }, []);

  // Gets user data sent through GET params
  useEffect(() => {
    if (address === undefined) return;
    dispatch(storeParams(partnerCode, address, code, idate, uid));
    dispatch(getRates(1));
  }, []);

  // 'global' max/min purchase amounts
  let minimum;
  let maximum;

  switch (currencyCode) {
    case "CAD":
      minimum = 60;
      maximum = 22000;
      break;
    case "EUR":
      minimum = 40;
      maximum = 16000;
      break;
    case "JPY":
      minimum = 5500;
      maximum = 2100000;
      break;
    case "USD":
      minimum = 50;
      maximum = 20000;
      break;
    default:
      console.error("unrecognised currency");
  }

  // check if safe to enable to disable progress button
  // button is disabled if over/below purchase limits
  // or if any errors are found
  useEffect(() => {
    if (fiat_amount < minimum || fiat_amount > maximum) {
      setButtonDisabled(true);
    } else {
      // check if no errors exist first?
      if (messages.length !== 0 || messages === undefined) {
        setButtonDisabled(true);
      } else {
        if (parseFloat(fiat_amount) === 0) {
          setButtonDisabled(true);
        } else {
          setButtonDisabled(false);
        }
      }
    }
  }, [fiat_amount, messages]);

  const Errors = messages.map((err) => {
    return (
      <Error messages={err} key={err} onClick={() => dispatch(resetError())} />
    );
  });

  return (
    <div>
      {Errors}
      {payID === false ? (
        <Error
          messages={`payment_id: ${order_id}`}
          key={order_id}
          onClick={() => hidePayID(true)}
        />
      ) : null}

      <Balance />
      <Crypto />
      <Numpad />
      <InfoBox>
        <InfoText>
          Minimum purchase of {currencySymbol}
          {minimum}. Maximum of {currencySymbol}
          {maximum}.
        </InfoText>
      </InfoBox>
      <Button
        disabled={buttonDisabled}
        title="Next"
        onClick={() => navigate("/confirm")}
      />
    </div>
  );
};

const InfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e6e7e8;
`;

const InfoText = styled.p`
  color: #b3b3b3;
  font-family: Helvetica;
  font-size: 12px;
  margin-top: 6px;
  margin-bottom: 6px;
`;

export default Buy;
